import {hasImage} from '@wix/wix-events-commons-statics'
import React from 'react'
import {useWidgetState} from '../../../../../../hooks/state-provider'
import {useVisibilityStyles} from '../../../../../../hooks/use-visibility-styles'
import {getSelectedEventId} from '../../../../../../selectors/calendar-layout'
import {getEventBadge, getEventById} from '../../../../../../selectors/events'
import {EventBadge} from '../../../../../event-badge'
import {EventImage} from '../../../../../event-image'
import {RsvpButton} from '../../../../../rsvp-button'
import {EventDetailsContent} from '../content'
import s from './side-by-side-layout.scss'

export const SideBySideEventDetailsLayout = () => {
  const {
    allBreakpoints: {isEventBadgeOnImage},
  } = useVisibilityStyles()

  const selectedEventId = useWidgetState(getSelectedEventId)
  const event = useWidgetState(state => getEventById(state, selectedEventId))
  const eventBadge = useWidgetState(state => getEventBadge(state, event))

  return (
    <div className={s.container}>
      {hasImage(event) && (
        <div aria-hidden className={s.image}>
          <EventImage noLQIP calendar event={event} />
          {isEventBadgeOnImage(eventBadge?.type) && <EventBadge onImage event={event} />}
        </div>
      )}
      <div className={s.contentContainer}>
        <div className={s.content}>
          <EventDetailsContent />
        </div>
        <RsvpButton
          calendar
          dataHook="rsvp-button"
          event={event}
          minWidth={88}
          minHeight={32}
          containerClassName={s.rsvpButton}
        />
      </div>
    </div>
  )
}
